// extracted by mini-css-extract-plugin
export default {"trim":"rebateTrims_trim__HBJ-B","formGroup":"rebateTrims_formGroup__gnXX3","deleteCol":"rebateTrims_deleteCol__fi4Aj","addCol":"rebateTrims_addCol__bjyw6"};